import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, combineLatest, from, Observable, of, Subscription, throwError } from 'rxjs';
import { map, shareReplay, startWith, tap } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { MY_FORMATS } from 'src/app/_models/moment-formats';
import { GlobalService } from 'src/app/_services/global.service';
import { HorarioService } from 'src/app/_services/horario.service';
import { EstudioService } from '../../estudio/estudio.service';
import { MapaCurricularService } from '../../estudio/mapa-curricular/_services/mapa-curricular.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { HorarioActividadesImportarComponent } from '../horario-actividades-importar/horario-actividades-importar.component';
import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-calendario-importar',
  standalone: false,
  templateUrl: './calendario-importar.component.html',
  styleUrls: ['../calendario.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CalendarioImportarComponent implements OnInit, OnDestroy {

  listaNoSubjects = [
    'Reunión'
    , 'Oración'
    , 'Profesional'
    , 'Comité'
    , 'Conciliación'
    , 'Consejo'
    , 'Lunch'
    , 'Saludo'
    , 'Trabajo personal'
    , 'Break'
    , 'Buses'
    , 'Closure'
    , 'Filas'
    , 'Nap'
    , 'Recess'
    , 'Charla'
  ];

  fileData: File;
  data: any;
  materias$: Observable<any[]>;
  materiasPeriodo$: Observable<any[]>;
  cursos$: Observable<any>;
  profesores$: Observable<any>;

  classes$: Observable<any[]>;
  subjects$: Observable<any[]>;
  teachers$: Observable<any[]>;

  formSubjects = new UntypedFormArray([]);
  formClasses = new UntypedFormArray([]);
  formTeachers = new UntypedFormArray([]);
  fechaForm = new UntypedFormControl('', Validators.required);

  archivoForm = new UntypedFormGroup({
    archivo: new UntypedFormControl('', Validators.required),
    escuela: new UntypedFormControl(0, Validators.required),
  });

  loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  terminadoSubject = new BehaviorSubject<boolean>(false);
  terminado$ = this.terminadoSubject.asObservable();

  subscriptions: Subscription[] = [];

  escuelas$ = this.globalService.tipoGenerico('TipoSeccionCurso').pipe(shareReplay(1));

  escuela$ = combineLatest([this.escuelas$, this.archivoForm.valueChanges]).pipe(
    map(([escuelas, id]) => {
      if (id.escuela !== 0 && escuelas) {
        return escuelas.find(item => item.key === id.escuela).value;
      } else {
        return '';
      }
    }),
    shareReplay(1)
  );

  constructor(
    private title: Title,
    private dynamicBar: DynamicBarService,
    private estudioService: EstudioService,
    private globalService: GlobalService,
    private customAlert: CustomAlertService,
    private snackBar: MatSnackBar,
    private horarioService: HorarioService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.title.setTitle('Inicio/Horario Importar');
    this.dynamicBar.setBarra('barra-simple', {
      titulos: [
        { texto: 'Inicio', link: ['/'] },
        { texto: 'Horario', link: ['/', 'horario', 'listado'] },
        { texto: 'Importar', link: [] },
      ],
    });
    this.materiasPeriodo$ = this.estudioService.materiasPeriodo$;

const escuelaId$ = this.archivoForm.get('escuela').valueChanges.pipe(
  shareReplay(1));
escuelaId$.subscribe();
const cursosSinFiltrar$ = this.estudioService.cursosGroup$.pipe(
  map(data => {
    let result = [];
    data.forEach(item => {
      result = result.concat(item.cursos);
    });
    return result;
  })
);

this.cursos$ = combineLatest([cursosSinFiltrar$, escuelaId$]).pipe(
  map(([cursos, escuela]) => {
    if (escuela === 0) {
      return cursos;
    } else {
      return cursos.filter(item => {
        return item.seccion === escuela;
      });
    }
  })
);

const materiasFiltradas$ = combineLatest([this.materiasPeriodo$,
this.cursos$.pipe(map(data => data.map(item => item.id))), escuelaId$]).pipe(
  map(([materias, cursos, escuelaId]) => {
    if (escuelaId === 0) {
      return materias;
    } else {
      return materias.filter(item => cursos.includes(item.cursoID));
    }
  })
)

this.materias$ = materiasFiltradas$.pipe(
  map(data => {
    return data.map(item => item.materiaID + '|' + item.nombre + (item.detalle !== '' ? ' ' + item.detalle : '') + (item.mezcla !== '' ? ' ' + item.mezcla : ''));
  }),
  map(data => {
    return this.globalService.unique(data);
  }),
  map(data => {
    return data.map(item => {
      const pareja = item.split('|');
      return { id: pareja[0], nombre: pareja[1] };
    });
  }),
  shareReplay(1)
);


this.profesores$ = this.estudioService.profesores$.pipe(
  map(data => {
    const res = this.estudioService.extractData(data);
    res.forEach(element => {
      element.nombre = element.nombresApellidos;
    });

    return res.sort((a, b) => {
      if (a.nombresApellidos < b.nombresApellidos) { return -1; }
      if (a.nombresApellidos > b.nombresApellidos) { return 1; }
      return 0;
    });
  }),
  shareReplay(1));
  }

fileProgress(fileInput: any) {
  this.loadingSubject.next(true);
  this.fileData = <File>fileInput.target.files[0];
  const reader = new FileReader();
  reader.readAsText(this.fileData);
  reader.onload = (_event) => {
    try {
      this.data = JSON.parse(reader.result.toString());
      this.data.subjects = this.data.subjects.filter(item => {
        let noSubject = true;
        const subjectString = item.name + (item.shortName
          ? ' ' + item.shortName : '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        this.listaNoSubjects.forEach(unSubject => {
          if (subjectString.indexOf(unSubject) > -1) {
            noSubject = false;
          }
        });
        return noSubject;
      });
      const data$: Observable<any> = of(this.data);

      const matSubscription = this.materias$.subscribe(materias => {
        this.formSubjects = new UntypedFormArray([]);
        this.data.subjects.forEach(item => {
          const index = this.globalService.findBestMatch(item.name + (item.shortName ? ' ' + item.shortName : ''),
            materias.map(materia => materia.nombre)).bestMatchIndex;
          const materiaEncontrada = materias[index];
          this.formSubjects.push(new UntypedFormGroup({
            check: new UntypedFormControl(true),
            id: new UntypedFormControl(materiaEncontrada.id, Validators.required)
          }));
        });
        this.loadingSubject.next(false);
      });

      const cursoSubscription = this.cursos$.subscribe(cursos => {
        this.loadingSubject.next(true);
        this.formClasses = new UntypedFormArray([]);
        this.data.classes.forEach(item => {
          const index = this.globalService.findBestMatch(item.name,
            cursos.map(curso => curso.nombre)).bestMatchIndex;
          const cursoEncontrado = cursos[index];
          this.formClasses.push(new UntypedFormGroup({
            check: new UntypedFormControl(true),
            id: new UntypedFormControl(cursoEncontrado.id, Validators.required)
          }));
        });
        this.loadingSubject.next(false);
      });

      const profesoresSubscription = this.profesores$.subscribe(profesores => {
        this.formTeachers = new UntypedFormArray([]);
        this.data.teachers.forEach(item => {
          const index = this.globalService.findBestMatch(item.name,
            profesores.map(profesor => profesor.nombresApellidos)).bestMatchIndex;
          const profesorEncontrado = profesores[index];
          this.formTeachers.push(new UntypedFormGroup({
            check: new UntypedFormControl(true),
            id: new UntypedFormControl(profesorEncontrado.id, Validators.required)
          }));
        });
        this.loadingSubject.next(false);
      });
      this.subscriptions.push(matSubscription);
      this.subscriptions.push(cursoSubscription);
      this.subscriptions.push(profesoresSubscription);
    } catch (error) {
      this.customAlert.setCustomMessage({
        tipo: 'error',
        texto: `El archivo no es valido para la importación. No es un archivo JSON.`
      });
      this.loadingSubject.next(false);
      this.archivoForm.get('archivo').setValue('');
    }
  };
}

numeroRegistros() {
  let count = 0;
  this.formClasses.value.forEach(item => {
    if (item.check) {
      count += 1;
    }
  });
  this.formSubjects.value.forEach(item => {
    if (item.check) {
      count += 1;
    }
  });
  return count;
}

submit() {
  if (this.fechaForm.valid) {
    this.loadingSubject.next(true);
    const model = JSON.parse(JSON.stringify(this.data));
    const deleteSubject = [];
    const deleteClasses = [];
    const deleteTeachers = [];
    model.subjects.forEach((item, i) => {
      delete item.materia;
      const formValue = this.formSubjects.at(i).value;
      if (formValue.check) {
        item.materiaId = formValue.id;
      } else {
        deleteSubject.push(i);
      }
    });

    model.classes.forEach((item, i) => {
      delete item.curso;
      const formValue = this.formClasses.at(i).value;
      if (formValue.check) {
        item.cursoId = formValue.id;
      } else {
        deleteClasses.push(i);
      }
    });

    model.teachers.forEach((item, i) => {
      delete item.profesor;
      const formValue = this.formTeachers.at(i).value;
      if (formValue.check) {
        item.personaId = formValue.id;
      } else {
        deleteClasses.push(i);
      }
    });

    while (deleteClasses.length > 0) {
      const index = deleteClasses.pop();
      model.classes.splice(index, 1);
    }
    while (deleteSubject.length > 0) {
      const index = deleteSubject.pop();
      model.subjects.splice(index, 1);
    }
    while (deleteTeachers.length > 0) {
      const index = deleteTeachers.pop();
      model.subjects.splice(index, 1);
    }
    model.escuelaId = this.archivoForm.value.escuela;
    model.fechaInicio = moment(this.fechaForm.value).format('YYYY/MM/DD');
    this.horarioService.gurdarHorario(model).subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.length && res.length > 0) {
        const dialogo = this.matDialog.open(HorarioActividadesImportarComponent, {
          data: {
            actividades: res,
            data: this.data
          }
        });
      }
      this.terminadoSubject.next(true);
      this.snackBar.open('El horario fue guardado en el sistema.', null, { duration: 2500 });
    }, err => {
      this.loadingSubject.next(false);
      this.customAlert.setCustomMessage({
        tipo: 'error',
        texto: `Error al guardar el horario. ${err.error}`
      });
    });
  } else {
    this.fechaForm.markAllAsTouched();
  }
}

nuevaImportacion() {
  window.location.reload();
}

ngOnDestroy() {
  this.subscriptions.forEach(item => {
    item.unsubscribe();
  });
}

}
